import { ErrorBoundary } from "@sentry/react"
import ReactDom from "react-dom/client"

import App from "./App"
import Layout from "./layout"

import "@/utils/sentry"
import "@/styles/global.scss"

const Root: React.FC = () => {
    return (
        <ErrorBoundary>
            <Layout>
                <App />
            </Layout>
        </ErrorBoundary>
    )
}

const container = document.getElementById("root")
if (container) {
    const root = ReactDom.createRoot(container)
    root.render(<Root />)
}
